/* Copyright 2013 - 2024 Waiterio LLC */
import ENVIRONMENT from '@monorepool/env/ENVIRONMENT.js'
import IS_DEVELOPMENT from '@monorepool/env/IS_DEVELOPMENT.js'
import IS_TESTING from '@monorepool/env/IS_TESTING.js'
import * as Sentry from '@sentry/browser'

let sentry

export default function getSentryBrowser() {
  if (!sentry && !IS_DEVELOPMENT && !IS_TESTING) {
    let dsn
    let release

    if (typeof window !== 'undefined') {
      dsn = window.SENTRY_DSN

      if (!dsn) {
        console.warn('Missing window.SENTRY_DSN')
      }

      // Set in the HTML by getWindowVariablesScript from the webpack
      // MONOREPO_VERSION (version.js). Tags every event with the release so
      // Sentry can match it to the sourcemaps uploaded for that release.
      release = window.MONOREPO_VERSION || undefined
    }

    Sentry.init({
      dsn,
      environment: ENVIRONMENT,
      release,
    })

    sentry = Sentry
  }

  return sentry
}
